class MergedPosition {
    constructor({ stockId, symbol, companyName, percentageOfAllInvestment, value, amountInvested, userPositionDetails, signifiantStockDayEvolution }) {
        this._stockId = stockId
        this._symbol = symbol
        this._companyName = companyName
        this._percentageOfAllInvestment = percentageOfAllInvestment
        this._value = value
        this._amountInvested = amountInvested
        this._userPositionDetails = userPositionDetails
        this._signifiantStockDayEvolution = signifiantStockDayEvolution
    }

    get stockId() {
        return this._stockId
    }

    get symbol() {
        return this._symbol.toUpperCase()
    }

    get stockSymbol() {
        return this._symbol.toUpperCase()
    }

    get companyName() {
        return this._companyName
    }

    get currency() {
        return this._signifiantStockDayEvolution.currency
    }

    get price() {
        return this._signifiantStockDayEvolution.singleShareCurrentPrice
    }

    get percentageOfAllInvestment() {
        return this._percentageOfAllInvestment
    }

    get stockValue() {
        return this._value
    }

    get amountInvested() {
        return this._amountInvested
    }

    get userPositionDetails() {
        return this._userPositionDetails
    }

    get signifiantStockDayEvolution() {
        return this._signifiantStockDayEvolution
    }

    get remainingStockShareCount() {
        return this._userPositionDetails ? this._userPositionDetails.remainingStockShareCount : 0
    }

    get totalDayChange() {
        return {
            change: this._userPositionDetails.totalDayGain,
            price: this._signifiantStockDayEvolution.singleShareCurrentPrice
        }
    }

    get totalChange() {
        return {
            change: this._userPositionDetails.totalProfitIncludingUnrealized,
            price: this._signifiantStockDayEvolution.singleShareCurrentPrice
        }
    }
}

export default MergedPosition